import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { isPersonTravellingWith } from '../../../../../utilities/pages';
import { useTranslation } from "react-i18next";

function VisaPrepFamilyStep4(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.GUARDIANS_PERSONAL_DETAILS}
        label={t('forms.visa:doYouHaveAGuardianThatYouHaveNot')}
        value={boolToYesNo(props.hasGuardiansPersonalDetails)}
      />
      {props.hasGuardiansPersonalDetails === true ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.GUARDIAN_NATIONALITY}
            value={props.guardianNationality}
            label={t('forms.visa:guardianSNationality')}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.GUARDIAN_SAME_NATIONALITY}
            label={t('forms.visa:haveTheyAlwaysHadTheSameNational')}
            value={boolToYesNo(props.guardianSameNationality)}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.GUARDIAN_FAMILY_NAME}
            value={props.guardianFamilyName}
            label={t('forms.visa:guardianSFamilyName')}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.GUARDIAN_GIVEN_NAME}
            value={props.guardianGivenName}
            label={t('forms.visa:guardianSGivenName')}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.GUARDIAN_DOB}
            label={t('forms.visa:guardianSDateOfBirth')}
            value={props.guardianDob}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.GUARDIAN_PLACE_OF_BIRTH}
            value={props.guardianPlaceOfBirth}
            label={t('forms.visa:guardianSPlaceOfBirth')}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.GUARDIAN_TRAVELLING_WITH}
            label={t('forms.visa:isThisPersonTravellingWithYou')}
            value={props.guardianTravellingWith}
          />
          {isPersonTravellingWith(props.guardianTravellingWith) ? (
            <>
              <SummaryRow
                className={'visa-summary'}
                key={VQ.GUARDIAN_UK_VISA}
                label={t('forms.visa:doTheyHaveAVisaForTheUk')}
                value={props.guardianUkVisa}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.GUARDIAN_HAS_PASSPORT}
                label={t('forms.visa:doTheyHaveAPassportOrTravelDocum')}
                value={boolToYesNo(props.guardianHasPassport)}
              />
              {props.guardianHasPassport ? (
                <SummaryRow
                  className={'visa-summary'}
                  key={VQ.GUARDIAN_PASSPORT_NUMBER}
                  value={props.guardianPassportNumber}
                  label={t('forms.visa:currentPassportOrTravelDocumentN')}
                />
              ) : null}
            </>
          ) : null}
        </>
      ) : null}
    </>
  );
}

export default VisaPrepFamilyStep4;
